import { css, useTheme } from '@emotion/react'
import Image from './Image'

function Avatar({
    children,
    size,
    imgSrc = '/img/shared/avatar.gif',
    alt,
    isImg = true,
    rounded = true,
    color = 'white',
    bgColor = 'danger',
    fontSize,
    boxSize,
    style,
    // OR
    // src = '',
    // title = '',
    // icon = null
}) {
    const theme = useTheme()
    //TODO make into switch
    let tSize = ''
    if (size === 'medium') {
        size = '40px'
        tSize = '1.2rem'
    } else if (size === 'small') {
        size = '24px'
        tSize = '0.8rem'
    } else if (size === 'large') {
        size = '56px'
        tSize = '1.8rem'
    } else if (fontSize || boxSize) {
        size = boxSize
        tSize = fontSize
    }

    const { objectFit, ...otherStyles } = style ?? {}

    if (isImg)
        return (
            <Image
                noStyle
                src={imgSrc}
                alt={alt}
                width={size}
                height={size}
                objectFit={objectFit}
                style={{
                    borderRadius: rounded
                        ? '100px'
                        : '2px',
                    ...otherStyles
                }}
            />
        )
    return (
        <span
            css={css`
                    width: ${size};
                    height: ${size};
                    overflow: hidden;
                    display: flex;
                    background-color: ${theme.colors?.[bgColor]};
                    color: ${theme.colors?.[color]};
                    justify-content: center;
                    align-items: center;
                    font-size: ${tSize};
                    padding: 0;
                    ${rounded === true
                    ? 'border-radius: 100px'
                    : 'border-radius: 2px'};
                `}
        >
            {children}
        </span>
    )
}

export default Avatar
